import React from 'react';
import {Heading, HStack, VStack} from 'native-base';
import {AccountIcon} from '../../../../components/icons';
import {message} from '../../../../utils/messages';

interface Props {
  label: string;
}

const ProfileTitle = ({label}: Props) => {
  return (
    <HStack paddingY={3}>
      <VStack width={'85%'} justifyContent={'center'}>
        <Heading
          color="gray.600"
          size="md"
          fontWeight="extrabold"
          width={'100%'}
          alignItems="center">
          {message(label)}
        </Heading>
      </VStack>
      <HStack width={'15%'}>
        <AccountIcon width={40} />
      </HStack>
    </HStack>
  );
};

export default ProfileTitle;
